/* unplugin-vue-components disabled */import { render } from "./Search.vue?vue&type=template&id=4fd5697e&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=4fd5697e&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd5697e"],['__file',"src/baseui/search/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fd5697e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fd5697e', __exports__)) {
    console.log('reload')
    api.reload('4fd5697e', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=4fd5697e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4fd5697e', render)
  })

}


export default __exports__